export default {
  locale: "es",
  name: "Clientes",
  translation: { displayName: "Traducciones" },
  fields: {
    list: [],
    form: [],
  },
};
